import React from 'react';
import { Route, Routes } from 'react-router-dom';
import ListPrinter from './pages/ListPrinter';
import CreatePrinter from './pages/CreatePrinter';
import EditPrinter from './pages/EditPrinter';

const Printer = () => {
  return (
    <Routes>
      <Route path="/" element={<ListPrinter />} />
      <Route path="/create" element={<CreatePrinter />} />
      <Route path="/edit/:id" element={<EditPrinter />} />
    </Routes>
  );
};

export default Printer;
